import { useEffect as __mpUseEffect, useState as __mpUseState } from "react";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const __MP_CONTROLS = [{
  "id": "leadSource",
  "label": "Lead Source",
  "kind": "select",
  "group": "Options",
  "default": "servicing",
  "options": [{
    "value": "servicing",
    "label": "Servicing"
  }, {
    "value": "prospect",
    "label": "Prospect"
  }, {
    "value": "directMail",
    "label": "Direct Mail"
  }, {
    "value": "vaCashout",
    "label": "Va Cashout"
  }, {
    "value": "internet",
    "label": "Internet"
  }, {
    "value": "cashoutProspect",
    "label": "Cashout Prospect"
  }, {
    "value": "rateTermIrrrl",
    "label": "Rate Term Irrrl"
  }, {
    "value": "newHomeListing",
    "label": "New Home Listing"
  }, {
    "value": "nerdWallet",
    "label": "Nerd Wallet"
  }]
}, {
  "id": "side",
  "label": "Side",
  "kind": "select",
  "group": "Options",
  "default": "right",
  "options": [{
    "value": "left",
    "label": "Left"
  }, {
    "value": "right",
    "label": "Right"
  }]
}, {
  "id": "defaultExpanded",
  "label": "Default Expanded",
  "kind": "toggle",
  "group": "Options",
  "default": true
}];
function __mpIsValidControlValue(control, value) {
  if (control.kind === 'toggle') return typeof value === 'boolean';
  if (control.kind === 'number') {
    return typeof value === 'number' && Number.isFinite(value);
  }
  if (typeof value !== 'string' || value.length > 10000) return false;
  if (control.kind === 'select') {
    return control.options?.some(option => option.value === value) ?? false;
  }
  if (control.kind === 'color') {
    return /^#[0-9a-f]{6}$/i.test(value);
  }
  return true;
}
function __MPControlsRoot() {
  const [overrides, setOverrides] = __mpUseState({});
  __mpUseEffect(() => {
    const handleValues = event => {
      const nextValues = event.detail?.values;
      if (!nextValues || typeof nextValues !== 'object' || Array.isArray(nextValues)) {
        return;
      }
      const normalized = {};
      for (const control of __MP_CONTROLS) {
        const value = nextValues[control.id];
        if (__mpIsValidControlValue(control, value)) {
          normalized[control.id] = value;
        }
      }
      setOverrides(normalized);
    };
    const announceControls = () => {
      window.dispatchEvent(new CustomEvent('magicpatterns:controls-ready', {
        detail: {
          controls: __MP_CONTROLS
        }
      }));
    };
    window.addEventListener('magicpatterns:controls-values', handleValues);
    window.addEventListener('magicpatterns:controls-request', announceControls);
    announceControls();
    return () => {
      window.removeEventListener('magicpatterns:controls-values', handleValues);
      window.removeEventListener('magicpatterns:controls-request', announceControls);
    };
  }, []);
  return <App {...overrides} />;
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<__MPControlsRoot />);
}